import { useMemo } from "react";
import { useRules } from "../../../hooks/useRules";

export interface RuleScopeCounts {
  all: number;
  hcm: number;
  svp: number;
  b340: number;
}

/**
 * Live counts of rules per manual, fed into the AppShell sub-nav.
 *
 * Reuses the same `useRules({page:1,size:1000})` query that
 * `ComplianceRulesPage` already runs, so react-query dedupes the request.
 */
export function useRuleScopeCounts(enabled: boolean): RuleScopeCounts | null {
  const { data } = useRules({ page: 1, size: 1000 }, { enabled });

  return useMemo<RuleScopeCounts | null>(() => {
    if (!enabled) return null;
    const rules = data?.data?.content;
    if (!Array.isArray(rules)) return null;
    let hcm = 0;
    let svp = 0;
    let b340 = 0;
    for (const r of rules) {
      const rn = (r.ruleNumber || "").trim().toUpperCase();
      if (!rn) continue;
      const manual = rn.split(".")[0];
      if (manual === "HCM") hcm++;
      else if (manual === "SVP") svp++;
      else if (manual === "340B") b340++;
    }
    return { all: rules.length, hcm, svp, b340 };
  }, [data, enabled]);
}
